import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  Stack,
} from '@mui/material';

const ConfirmationModal = ({
  open,
  handleClose,
  handleConfirm,
  title = 'Confirm Status Change',
  message = 'Are you sure you want to change this user status?',
  confirmLabel = 'Confirm',
  loading = false,
}) => {
  const handleConfirmClick = () => {
    handleConfirm();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: 'calc(100% - 32px)', sm: 400 },
          maxWidth: 'calc(100vw - 32px)',
          boxSizing: 'border-box',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: { xs: 2.5, sm: 4 },
          borderRadius: 3,
          outline: 'none',
        }}
      >
        <Typography
          id='modal-modal-title'
          variant='h6'
          component='h2'
        >
          {title}
        </Typography>
        <Typography id='modal-modal-description' sx={{ mt: 2 }}>
          {message}
        </Typography>
        <Stack
          direction='row'
          spacing={2}
          justifyContent='flex-end'
          sx={{ mt: 3 }}
        >
          <Button
            onClick={handleClose}
            variant='outlined'
            disabled={loading}
            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmClick}
            variant='contained'
            disabled={loading}
            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
          >
            {loading ? 'Please wait…' : confirmLabel}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
